export const ABOUT: string = 'About';
export const CONTACT: string = 'Contact';
export const DEFAULT: string = 'Element 43';
export const NOT_FOUND = 'Twilight zone';
export const PORTFOLIO = 'Portfolio';
